import { render } from "./DictTypesShow.vue?vue&type=template&id=4482db72&scoped=true"
import script from "./DictTypesShow.vue?vue&type=script&lang=js"
export * from "./DictTypesShow.vue?vue&type=script&lang=js"

import "./DictTypesShow.vue?vue&type=style&index=0&id=4482db72&scoped=true&lang=scss"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4482db72"]])

export default __exports__